<div class="container">
  <h1 class="display-5 fw-semibold">Agenda</h1>
  <h2 class="h4 text-muted mb-4">Próximos eventos</h2>

  <div class="row mb-4 align-items-end gy-2">
    <div class="col-md-6 d-flex">
      <div>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input
            type="text"
            class="form-control"
            placeholder="Buscar"
            [(ngModel)]="params.title"
            (ngModelChange)="handleSearch()"
          />
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <select class="form-select">
        <option value="" selected disabled hidden>Ordenar por</option>
        <option value="recent">Más reciente</option>
        <option value="oldest">Más antiguo</option>
      </select>
    </div>
    <div class="col-md-3">
      <input
        type="date"
        class="form-control"
        [(ngModel)]="params.date"
        (ngModelChange)="getEvents()"
      />
    </div>
  </div>

  <div class="row g-4">
    @for (event of events; track event.id) {
      <div class="col-md-4">
        <a [routerLink]="['/agenda', event.id]">
          <div class="card shadow-sm h-100">
            <div class="position-relative">
              <img [src]="event.image_url" class="card-img-top" alt="Ponente" />
              <span
                class="badge bg-white text-dark position-absolute bottom-0 end-0 m-2 px-2 py-1 shadow-sm"
              >
                <i class="bi bi-calendar-week-fill me-1"></i>
                {{ event.date | date: 'd MMM' }}
              </span>
            </div>
            <div class="card-body">
              <h5 class="card-title">{{ event.title }}</h5>
              <p class="card-text text-muted mb-0">
                <i class="bi bi-cursor-fill me-1"></i>
                {{ event.location_name }}
              </p>
            </div>
          </div>
        </a>
      </div>
    } @empty {
      @if (loading) {
        @for (placeholder of [1, 2, 3, 4, 5, 6]; track placeholder) {
          <div class="col-md-4">
            <div class="card shadow-sm h-100 placeholder-glow">
              <div class="position-relative">
                <img
                  src="/assets/img/placeholder.png"
                  class="card-img-top"
                  alt="Ponente"
                />
                <span
                  class="badge bg-white text-dark position-absolute bottom-0 end-0 m-2 px-2 py-1 shadow-sm"
                >
                  <span class="placeholder col-12"></span>
                </span>
              </div>
              <div class="card-body">
                <h5 class="card-title">
                  <span class="placeholder col-8"></span>
                </h5>
                <p class="card-text text-muted mb-0">
                  <span class="placeholder col-6"></span>
                </p>
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="col-12">
          <div class="alert alert-secondary text-center" role="alert">
            No hay eventos programados.
          </div>
        </div>
      }
    }
  </div>
</div>
